import DispositivosForm from "./DispositivosForm";
export default DispositivosForm;